module.exports = Edu;